import React, { memo } from 'react';
import { CategoryIcon } from './CategoryIcon';
import { resolveBoostVisual } from '../lib/mapConfig';

// Marcador de estabelecimento.
// - comum: estático, discreto, cor da marca, ícone da categoria;
// - com promoção ativa (sem boost): anel de pulso suave vermelho;
// - impulsionado: anel de pulso + selo, com variações por plano (preparadas).
export const BusinessMarker = memo(function BusinessMarker({ business, onClick }) {
  const visual = resolveBoostVisual(business);

  const className = [
    'nc-map-marker',
    visual?.boosted ? 'nc-map-marker-boosted' : '',
    visual?.promo ? 'nc-map-marker--promo' : '',
    visual?.planKey && visual.planKey !== 'boosted' ? `nc-map-marker--plan-${visual.planKey}` : '',
    visual?.boosted && visual.priority && visual.priority <= 2 ? 'nc-map-marker--lg' : '',
  ].filter(Boolean).join(' ');

  const boosted = Boolean(visual?.boosted);
  const ariaLabel = `Abrir detalhes de ${business.name}${boosted ? ' — impulsionado' : ''}`;

  return (
    <button
      type="button"
      className={className}
      aria-label={ariaLabel}
      title={`${business.name}${boosted ? ' ⚡ impulsionado' : ''}`}
      onClick={onClick}
      style={{
        '--nc-ring-color': visual ? visual.color : undefined,
        background: visual ? visual.color : 'var(--nc-primary)',
      }}
    >
      <CategoryIcon category={business.category} size={18} />
      {visual?.seal ? (
        <span className="nc-map-marker__seal" aria-hidden="true">
          {visual.seal}
        </span>
      ) : null}
    </button>
  );
});

// Marcador de cluster: mostra a quantidade de estabelecimentos agrupados.
export const ClusterMarker = memo(function ClusterMarker({ cluster, onClick }) {
  const count = cluster.count;
  return (
    <button
      type="button"
      className={`nc-map-cluster${count >= 10 ? ' nc-map-cluster--lg' : ''}`}
      onClick={onClick}
      aria-label={`${count} estabelecimentos agrupados — toque para ampliar`}
      title={`${count} estabelecimentos`}
    >
      <span className="nc-map-cluster__count">{count}</span>
    </button>
  );
});
